// removed by extract-text-webpack-plugin
module.exports = {"roles-content-wrapper":"roles-content-wrapper","rolesContentWrapper":"roles-content-wrapper","roles-content-left-hand":"roles-content-left-hand","rolesContentLeftHand":"roles-content-left-hand","role-name":"role-name","roleName":"role-name","edit-role-info":"edit-role-info","editRoleInfo":"edit-role-info","roles-content-right-hand":"roles-content-right-hand","rolesContentRightHand":"roles-content-right-hand","roles-content-body":"roles-content-body","rolesContentBody":"roles-content-body"};


//////////////////
// WEBPACK FOOTER
// ./src/components/roles/editRole/style.scss
// module id = 1636
// module chunks = 0